import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import {QueryClientProvider} from '@tanstack/react-query';
import {BoundaryFallback} from '@kcast-fe/ui-kit';
import {queryClient} from '@kcast-fe/core';
import * as Sentry from '@sentry/react';

import {initLogger, ServiceWorkerRegistration} from './core';
import {ThemeProvider} from './ui-kit';
import App from './scenes/App';

initLogger();

createRoot(document.getElementById('root')!).render(
  <ThemeProvider>
    <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
      <Sentry.ErrorBoundary fallback={<BoundaryFallback />}>
        <QueryClientProvider client={queryClient}>
          <ToastContainer hideProgressBar />
          <App />
        </QueryClientProvider>
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </ThemeProvider>
);

ServiceWorkerRegistration.register();
